export interface CurrentBookingVehicleSummary {
  vehicleName: string;
  vehicleNum: string;
  registrationNumber: string;
  imageUrl?: string;
  speed?: string;
  range?: string;
  hubName?: string;
  /** Vehicle model display name from booking / hub vehicle */
  modelName?: string;
  currentPlanName?: string;
  bookingAmount?: number | null;
  planStartDate?: string | null;
  planEndDate?: string | null;
}

export function formatCurrentVehicleDetailValue(raw: string | null | undefined): string {
  const s = String(raw ?? "").trim();
  if (s === "") return "N/A";
  const lower = s.toLowerCase();
  if (
    s === "—" ||
    s === "–" ||
    s === "-" ||
    s === "--" ||
    s === "__" ||
    s === "___" ||
    lower === "n/a" ||
    lower === "na" ||
    lower === "null" ||
    lower === "undefined"
  ) {
    return "N/A";
  }
  if (/^[\u2013\u2014\u2015\u2212\-_.\s]+$/.test(s)) {
    return "N/A";
  }
  return s;
}
